import React from 'react';
import strings from '../../../assets/localization';
import classes from './FeatureIcons.module.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// We are using this library
// https://github.com/akiran/react-slick
const FeatureIcons = () => {
  return (
    <div className={classes.MainWrapper}>
      <div>
        <div className={classes.CarouselWrapper}>
          <div className={classes.SvgHolder}>
            <svg className={classes.Chat}>
              <use xlinkHref='/sprites.svg#icon-chat-filled' />
            </svg>
          </div>
          <p>{strings.FeaturesChat}</p>
          <p>{strings.SendMessagesToWhoYouWant}</p>
        </div>
        <div className={classes.CarouselWrapper}>
          <div className={classes.SvgHolder}>
            <svg className={classes.QuickMatch}>
              <use xlinkHref='/sprites.svg#quick-match' />
            </svg>
          </div>
          <p>{strings.QuickMatch}</p>
          <p>{strings.GetDatesFast}</p>
        </div>
      </div>
      <div>
        <div className={classes.CarouselWrapper}>
          <div className={classes.SvgHolder}>
            <svg className={classes.View}>
              <use xlinkHref='/sprites.svg#icon-view' />
            </svg>
          </div>
          <p>{strings.ViewedMyProfile}</p>
          <p>{strings.SeeWhoIsInterestedInYou}</p>
        </div>
        <div className={classes.CarouselWrapper}>
          <div className={classes.SvgHolder}>
            <svg className={classes.Likes}>
              <use xlinkHref='/sprites.svg#icon-heart-likes-filled' />
            </svg>
          </div>
          <p>{strings.LikesMe}</p>
          <p>{strings.SeeWhoIsInterestedInYou}</p>
        </div>
      </div>
    </div>
  );
};

export default FeatureIcons;
